import React, { useState, useEffect } from "react";
import { Typography, Grid, Button } from "@material-ui/core";
import {
  RequestsQuery,
  loadAccountListAll,
  RequestsQueryFilter,
} from "../utils/Actions";
import { GRID_DEFAULT_LOCALE_TEXT } from "../config/localeDatagrid";
import { Loading } from "../atoms";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import TextField from "@material-ui/core/TextField";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@material-ui/data-grid";
import moment from "moment/min/moment-with-locales";
import { Link } from "react-router-dom";
import VisibilityIcon from "@material-ui/icons/Visibility";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import SearchIcon from "@material-ui/icons/Search";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import CachedIcon from "@material-ui/icons/Cached";
import DateRangeIcon from "@material-ui/icons/DateRange";

registerLocale("es", es);
moment.locale("es");

export default function Request() {
  const [state, setstate] = useState([]);
  const [visible, setVisible] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  useEffect(() => {
    (async () => {
      setstate((await RequestsQuery()).data);
    })();
  }, []);

  const buscarxfecha = async () => {
    if (startDate <= endDate) {
      let fechaini = new Date();
      let fechafin = new Date();
      fechaini = startDate;
      fechafin = new Date(endDate);
      fechaini.setHours(0, 0, 0, 0);
      fechafin.setHours(24, 0, 0, 0);
      console.log(fechafin);
      setstate((await RequestsQueryFilter(fechaini, fechafin)).data);
    } else {
      alert("La fecha inicial no puede ser mayor a la fecha final.");
    }
  };

  const cleanfilter = async () => {
    setStartDate(new Date());
    setEndDate(new Date());
    setstate((await RequestsQuery()).data);
  };

  const ExportCSV = ({ csvData, fileName }) => {
    let datauserexport = [];

    csvData.map((item) => {
      const data = {
        IDSOLICITUD: item.id,
        NOMBRE: item.name,
        TITULO: item.title,
        DESCRIPCION: item.description,
        COMENTARIOADMIN: item.descriptionadmin,
        FECHA_CREACION: item.createdAt,
      };
      datauserexport.push(data);
    });

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const exportToCSV = (csvData, fileName) => {
      const ws = XLSX.utils.json_to_sheet(datauserexport);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    };

    return (
      <Button
        variant="outlined"
        color="secondary"
        onClick={(e) => exportToCSV(csvData, fileName)}
      >
        Exportar a Excel
      </Button>
    );
  };

  const columns = [
    {
      field: "name",
      headerName: "Nombre",
      renderCell: (params) => <Typography> {params.value}</Typography>,
      width: 200,
    },
    {
      field: "title",
      headerName: "Título",
    },
    {
      field: "description",
      headerName: "Descripción",
      width: 200,
    },
    {
      field: "descriptionadmin",
      headerName: "Comentarios",
      width: 200,
    },

    {
      field: "createdAt",
      headerName: "Fecha Solicitud",
      width: 220,
      renderCell: (params) => (
        <Typography>
          {moment(params.value).format("MMMM Do YYYY, h:mm:ss a")}
        </Typography>
      ),
    },
    {
      field: "id",
      headerName: "Acciones",
      width: 150,
      renderCell: (params) => (
        <Link
          to={{
            pathname: `/editrequests?id=${params.value}`,
            state: { id: params.value },
          }}
        >
          <VisibilityIcon style={{ fontSize: 25 }} color="primary" />
        </Link>
      ),
      sortable: false,
    },
  ];

  function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ justifyContent: "flex-end" }}>
        <ExportCSV csvData={state} fileName={"Solicitudes"} />
      </GridToolbarContainer>
    );
  }

  return (
    <Grid
      container
      direction="column"
      style={{ height: "100vh", backgroundColor: "#fff", borderRadius: 5 }}
    >
      <Typography
        variant="h5"
        style={{
          marginBottom: 30,
          backgroundColor: "#fff",
          padding: 10,
          marginLeft: "auto",
          marginRight: "auto",
          borderRadius: 5,
        }}
      >
        <AssignmentIndIcon />
        Solicitudes de Personal
      </Typography>
      <Grid
        direction="row"
        spacing={0}
        style={{ marginBottom: 20 }}
        container
        justify="space-around"
        alignItems="center"
      >
        <div style={{ display: "inline", alignItems: "center" }}>
          <Typography
            style={{
              fontWeight: "bold",
              alignItems: "center",
              marginBottom: 5,
              paddingTop: 5,
              fontSize: 16,
            }}
          >
            {" "}
            <DateRangeIcon
              style={{
                fontSize: 17,
              }}
            />
            Fecha Inicial
          </Typography>

          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            startDate={startDate}
            endDate={endDate}
          />
        </div>
        <div style={{ display: "inline" }}>
          <Typography
            style={{
              fontWeight: "bold",
              alignItems: "center",
              marginBottom: 5,
              paddingTop: 5,
              fontSize: 16,
            }}
          >
            <DateRangeIcon
              style={{
                fontSize: 17,
              }}
            />
            Fecha Final
          </Typography>
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
          />
        </div>
        <Button
          variant="contained"
          color="secondary"
          onClick={(e) => buscarxfecha()}
          startIcon={<SearchIcon />}
        >
          Buscar
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={(e) => cleanfilter()}
          startIcon={<CachedIcon />}
          style={{ color: "#fff" }}
        >
          Limpiar
        </Button>
      </Grid>
      <DataGrid
        rows={state}
        columns={columns}
        autoPageSize={true}
        localeText={GRID_DEFAULT_LOCALE_TEXT}
        components={{
          Toolbar: CustomToolbar,
        }}
      />
      <Loading visible={visible} setVisible={setVisible} />
    </Grid>
  );
}
